import React, { useEffect, useRef } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import { Modal } from "antd";
import statementDataMapper from "@/views/accounts/ledger-card-data-mapper";
import { useStatement,useLegerCard } from "@/hooks/accounts/useCustomerAccount";
import { vfs } from "./vfs";
import {AccountRequestDto, LoanStatementType} from "@/shared/api/model";


 (pdfMake as any).vfs = vfs();


interface PdfLegerCardProps {
  title: string;
  show: boolean;
  statementRequest: AccountRequestDto;
  handleShow: (show: boolean) => void;
}

const PdfLegerCard: React.FC<PdfLegerCardProps> = ({
                                                     title,
                                                     show,
                                                     statementRequest,
                                                     handleShow,
                                                   }) => {
  const [statementQuery] = useLegerCard(statementRequest, show);
  const { isLoading, isError, data } = statementQuery;
  const iframeRef = useRef<HTMLIFrameElement>(null);


  useEffect(() => {
    const generatePDF = async () => {

      if (data) {
          const title = statementRequest.loanStatementType === LoanStatementType.LEDGER_CARD ? "Account Statement" :"Ledger Card";
        const dd = statementDataMapper(data,title);
        // @ts-ignore
        const pdfDocGenerator = pdfMake.createPdf(dd);

        if (window.matchMedia("(max-width: 500px)").matches) {
          pdfDocGenerator.download();
        } else {
          const dataUrl = await new Promise<string>((resolve) => {
            pdfDocGenerator.getDataUrl((url) => resolve(url));
          });

          if (iframeRef.current) {
            iframeRef.current.src = dataUrl;
          }
        }
      }
    };

    if (show) {
      generatePDF();
    }
  }, [data, show]);

  return (
      <Modal
          title={title}
          centered
          open={show}
          onOk={() => handleShow(false)}
          onCancel={() => handleShow(false)}
          width="80vw"
          style={{ width: "100%", resize: "horizontal", height: "90vh" }}
      >
        <div className="flex h-full">
          {isLoading && <p>Loading...</p>}
          {isError && <p>Error loading statement</p>}
          {!isLoading && !isError && (
              <iframe
                  ref={iframeRef}
                  style={{ width: "100%", height: "70vh", border: "none" }}
                  title="PDF Statement"
              />
          )}
        </div>
      </Modal>
  );
};

export default PdfLegerCard;